import BiasPopupContent from './BiasPopupContent';

export default BiasPopupContent;
